import {Component, OnInit, ViewEncapsulation} from '@angular/core';
import * as d3 from 'd3';
import {BarChart} from './barchart.js';

@Component({
  selector: 'app-gl-ei-same-effort',
  templateUrl: './gl-ei-same-effort.component.html',
  styleUrls: ['../visualizations-common.scss'],
  encapsulation: ViewEncapsulation.None
})
export class GlEiSameEffortComponent implements OnInit {
  data: Array<any>;
  barchart: BarChart;

  constructor() { }

  ngOnInit() {
    d3.csv('assets/ccmsi_top_10_pct_workload.csv', d => {
      return {
        claims_caught: +d.claims_caught,
        data: [{
          model: 'gai',
          value: +d.gai
        },
          {
            model: 'org',
            value: +d.org
          }]
      };
    }).then(rows => {
      this.data = rows
      this.barchart = new BarChart('barchart', this.data);
    }).then(() => this.play());
  }

  async play() {
    const animationLength = 5000;
    let t = 0;
    for(let i=0; i <= 80; i=i+0.25) {
      t = Math.round(this.data.length/100*i);
      this.barchart.update(t)
      await this.sleep(animationLength/320);
    }
  }

  sleep(milliseconds)  {
    return new Promise(resolve => setTimeout(resolve, milliseconds))
  }
}
